import { render, staticRenderFns } from "./IcoPersonGraph.vue?vue&type=template&id=03ad612c"
import script from "./IcoPersonGraph.vue?vue&type=script&lang=js"
export * from "./IcoPersonGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports